import CSS from "csstype";
import HTMLReactParser from "html-react-parser";
import { zipObj } from "ramda";
import React, { useEffect, useRef, useState } from "react";
import { connect, ConnectedProps, useDispatch } from "react-redux";
import { Line } from "konva/types/shapes/Line";

import { buildingChainCategories } from "../../lib/constants";
import CityDialogTab from "./CityDialogTab";
import { setPositionToViewPort } from "../../lib/elementUtilities";
import { closeCityDialog, hirePop, releasePop } from "../../store/actions";

import { Slot, SlotType } from "../../lib/types";
import SlotPerson from "./SlotPerson";
import { getActiveSlotType } from "../../lib/commonFunctions";
import DemolishBuildingButton from "./DemolishBuildingButton";

interface IProps {
  // slotChain: SlotChain;
  slotChainKey: string;
  tab?: number;
  buildingElement?: Line;
  event?: any;
  xOffset?: number;
}

const mapStateToProps = (state: any) => ({
  freePops: state.governorate.population.free,
  gold: state.governorate.resources.gold,
  bricks: state.governorate.resources.bricks,
  slotChains: state.governorate.slotChains,
  slotPrices: state.governorate.slotPrices,
  allBuildings: state.governorate.allBuildings
});

const mapDispatchToProps = (dispatch: any) => ({
  closeCityDialogDispatch: () => dispatch(closeCityDialog())
})

const connector = connect(mapStateToProps, mapDispatchToProps);

const CityDialog = (props: IProps & ConnectedProps<typeof connector>) => {
  const dispatch = useDispatch();
  const subChains = new Map<string, { [key: string]: Slot }>();
  let businessCategory: any = {};
  const slotChain = props.slotChains[props.slotChainKey];

  Object.keys(slotChain)
    .filter(key => key === "slots" || !Number.isNaN(parseInt(key, 10)))
    .map(key => subChains
      .set(key, zipObj(Object.keys(slotChain[key]), Object.values(slotChain[key]))));
  // .set(key, zipObj(Object.keys(slotChain[key]), Object.values(slotChain[key]))));

  const [tab, setTab] = useState(subChains.keys().next().value);
  const [slot, setSlot] = useState<Slot>(Object.values(subChains.get(tab) || {})[0]);
  const [slotType, setSlotType] = useState<SlotType>(
    getActiveSlotType(Object.values(subChains.get(tab) || {})[0])
  );

  let businessCategoryKey = !Number.isNaN(parseInt(tab, 10))
    && Object.keys(buildingChainCategories).find(key => Object
      .keys(buildingChainCategories[key])
      .some(c => c === tab));
  businessCategory = businessCategoryKey && buildingChainCategories[businessCategoryKey];

  useEffect(
    () => {
      setTab(tab || subChains.keys().next().value);
      setSlot(Object.values(subChains.get(tab) || {})[0]);
      setSlotType(getActiveSlotType(Object.values(subChains.get(tab) || {})[0]));

      businessCategoryKey = !Number.isNaN(parseInt(tab, 10))
        && Object.keys(buildingChainCategories).find(key => Object
          .keys(buildingChainCategories[key])
          .some(c => c === tab));
      businessCategory = businessCategoryKey && buildingChainCategories[businessCategoryKey];
      return () => setTab(null);
    },
    [props.slotChainKey, props.slotChains]
  )

  const divRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = (e: any) => {
    if ((divRef.current && divRef.current.contains(e.target)) || e.target.localName === "a") {
      // inside click
      return;
    }
    // outside click
    props.closeCityDialogDispatch()
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);

  const [style, setStyle] = useState<CSS.Properties<string | number>>({ display: "block" });

  useEffect(() => {
    // const body = document.querySelector("body");
    let position: CSS.Properties<number> = {};
    console.log(props?.buildingElement?.getSelfRect());

    if (props.buildingElement) {
      position.left = (props.xOffset || 0) + props.buildingElement.getSelfRect().x
        - ((divRef.current ? divRef.current.getBoundingClientRect().width : 0) / 2);
      position.top = props.buildingElement.getSelfRect().y + 148;
    } else if (props.event) {
      position.left = (props.xOffset || 0) + props.event.evt.clientX + window.scrollX
        - (divRef.current ? divRef.current.getBoundingClientRect().width : 0) / 2;
      position.top = props.event.evt.clientY + window.scrollY;
    }

    if (divRef.current) {
      position = setPositionToViewPort(divRef.current, position);
    }

    setStyle({
      ...style,
      ...position
    })
  }, []);

  const handleTabChange = (key: string) => {
    setTab(key);
    setSlot(Object.values(subChains.get(key) || {})[0]);
    setSlotType(getActiveSlotType(Object.values(subChains.get(key) || {})[0]));
  }

  return (
    <div className="city-dialog city-dialog-tabs" style={style} ref={divRef}>
      { subChains.has(tab)
        ? <>
          {businessCategory
          && <header className="dialog-tabs">
            <ul>
              {[...Array.from(subChains.keys())]
                .map(key => <CityDialogTab
                  key={key}
                  active={key === tab}
                  disabled={!subChains.has(key)}
                  plus={subChains.has(key) && !!subChains.get(key)?.plus}
                  minus={subChains.has(key) && !!subChains.get(key)?.minus}
                  business={businessCategory[key]}
                  clicked={() => subChains.has(key) && handleTabChange(key)}
                />)}
            </ul>
          </header>
          }
        <div className="tabs-dialog-body">
          <div style={{ display: "flex" }}>
            <SlotPerson
              slot={slot}
              slotPrices={props.slotPrices}
              allBuildings={props.allBuildings}
              slotType={slotType}
            />
            <div style={{
              width: "207px",
              display: "flex",
              flexFlow: "column",
              justifyContent: "space-around"
            }}>
            <h3 className="h3">{slotType.name}</h3>
            <p className="white">
              {HTMLReactParser(`${slotType.descriptionHtml}${slotType.maintenance
                ? `<br />-${slotType.maintenance} <i class="icon icon-sm icon-zlato gold align-sub"></i> per turn`
                : ""}`)}
            </p>
              <div style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                paddingBottom: "4px"
              }}>
                <span className={"white"}>HP {slot.hp}/{slot.fullHp}
                </span>
                <span>
                  <DemolishBuildingButton
                    slot={slot}
                    price={props.slotPrices[slot.type.id]}
                    classes={"middle icon-md"}
                  />
                </span>
              </div>
            </div>
          </div>
          <div style={{ paddingLeft: "8px" }}>
            {slotType.maxPops > 0
              ? Array(slotType.maxPops).fill(0)
                .map(
                  (e: any, index: number) => (
                    (slotType.popPossible) < index + 1
                    && <i key={`pop${index}`} className="icon icon-md icon-zamek disabled"/>)
                    || (slot.pops < index + 1
                      ? <a key={`pop${index}`}
                           className={`icon icon-md icon-pop grey`}
                           onClick={() => props.freePops
                             && dispatch(hirePop(slot.id))}
                      />
                      : <a key={`pop${index}`}
                           className="icon icon-md icon-pop"
                           onClick={() => dispatch(releasePop(slot.id))}
                      />)
                )
              : <i className="icon"/>}
          </div>
        </div>
        </> : <span>Loading</span> }
    </div>
  )
};

export default connector(CityDialog);
